import { createContext, PropsWithChildren, useContext } from 'react'

const GeoCityContext = createContext<string | null>(null)

export const GeoCityProvider = ({ value, children }: PropsWithChildren<{ value: string | null }>) => (
  <GeoCityContext.Provider value={value}>{children}</GeoCityContext.Provider>
)

export const useGeoCity = () => useContext(GeoCityContext)
